// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/Transactions.jsx.
 * Loaded AFTER index.css (and after the page's own inline \\3c style>) so
 * equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * Strategy:
 *   - Tablet (<=991px): toolbar wraps, status-tabs are compact.
 *   - Mobile (<=576px): full single-column layout, table → card view,
 *     detail drawer → bottom sheet, all touch targets >=44px.
 *
 * DO NOT EDIT src/index.css. All overrides live here.
 */

/* ===========================================================================
 * TABLET (<=991px): compact toolbar & minor layout tweaks
 * ======================================================================== */
@media (max-width: 991px) {
  /* Allow toolbar to wrap so filter buttons don't clip */
  .transactions-page .table-toolbar {
    flex-wrap: wrap;
  }

  /* Search expands to fill available width on tablet */
  .transactions-page .search-box {
    max-width: 100%;
    flex: 1 1 220px;
  }

  /* Status tabs: let the count drop below the label on small tablets */
  .transactions-page .status-tab {
    min-width: 80px;
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full single-column, app-like layout
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Page wrapper ---- */
  .transactions-page {
    gap: 16px;
  }

  /* ---- Page header: stack title + action button ---- */
  .transactions-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 0;
  }

  .transactions-page .page-header h1 {
    font-size: 22px;
  }

  .transactions-page .header-actions {
    display: flex;
  }

  .transactions-page .header-actions .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ---- Status tabs: horizontal scroll so all fit without wrapping awkwardly ---- */
  .transactions-page .status-tabs {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 8px;
    padding: 0 0 4px;
    /* hide scrollbar visually but keep it functional */
    scrollbar-width: none;
  }

  .transactions-page .status-tabs::-webkit-scrollbar {
    display: none;
  }

  .transactions-page .status-tab {
    flex-shrink: 0;
    min-width: 90px;
    padding: 10px 12px;
    min-height: 44px;
  }

  .transactions-page .status-tab .tab-count {
    font-size: 16px;
  }

  /* ---- Toolbar: stack search above filter buttons ---- */
  .transactions-page .table-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .transactions-page .search-box {
    max-width: 100%;
    width: 100%;
    flex: unset;
  }

  .transactions-page .search-box input {
    width: 100%;
    min-height: 44px;
  }

  .transactions-page .toolbar-actions {
    display: inline-grid;
    flex-wrap: wrap;
    gap: 8px;
  }
  .plan-choice-modal{max-width: 90%;
    width: 100%;
    margin: 0 auto;
    position: relative;
    top: -30px;}
  /* Toolbar buttons: minimum touch target */
  .transactions-page .btn-toolbar,
  .transactions-page .btn-clear-filters {
    min-height: 44px;
    padding: 10px 12px;
    flex-shrink: 0;
    width:100%;
  }

  /* Dropdown menus: full-width on mobile so they don't clip */
  .transactions-page .dropdown-menu {
    left: 0;
    right: auto;
    min-width: 200px;
    max-height: 60vh;
    overflow-y: unset;
    width: 100%;
    z-index: 9999;
  }

  /* ---- Table → card view ---- */

  /* Remove horizontal scroll from the container */
  .transactions-page .transactions-table-container {
    overflow: visible;
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
  }

  /* Hide the actual <table> – we use the card list instead */
  .transactions-page .transactions-table {
    display: none;
  }

  /* The card list is shown only on mobile via .tx-card-list */
  .transactions-page .tx-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Each transaction row becomes a card */
  .transactions-page .tx-row-card {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s;
  }

  .transactions-page .tx-row-card:active {
    background: var(--bg-secondary);
  }

  /* Card top row: amount (left) + status badge (right) */
  .transactions-page .tx-row-card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .transactions-page .tx-row-card-amount {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
  }

  /* Card bottom row: type·method + date */
  .transactions-page .tx-row-card-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .transactions-page .tx-row-card-meta {
    font-size: 12px;
    color: var(--text-secondary);
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    min-width: 0;
  }

  .transactions-page .tx-row-card-meta .tx-row-card-type {
    color: var(--text-muted);
  }

  .transactions-page .tx-row-card-date {
    font-size: 12px;
    color: var(--text-muted);
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* tx-hash chip on card */
  .transactions-page .tx-row-card-hash {
    font-family: 'Monaco', 'Menlo', monospace;
    font-size: 11px;
    color: var(--text-muted);
    margin-top: 6px;
  }

  /* empty/loading states still look good inside the transparent container */
  .transactions-page .transactions-table-container .empty-state,
  .transactions-page .transactions-table-container .loading-container {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
  }

  /* ---- Pagination ---- */
  .transactions-page .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .transactions-page .pagination-info {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    font-size: 13px;
  }

  .transactions-page .page-size-select {
    min-height: 44px;
  }

  .transactions-page .pagination-controls {
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .transactions-page .pagination-btn,
  .transactions-page .page-number {
    min-width: 44px;
    min-height: 44px;
  }

  /* ---- Detail drawer → bottom sheet ---- */

  /* Full-viewport overlay (already exists in inline style; this reinforces it) */
  .tx-drawer-overlay {
    /* already position: fixed with z-index: 999 — no change needed */
  }

  /* Bottom sheet: slides up from bottom, full-width, rounded top */
  .tx-detail-drawer {
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100% !important;       /* override the inline width:600px */
    max-width: 100% !important;
    height: 92vh;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);
    animation: txSlideUp 0.28s cubic-bezier(0.32, 0.72, 0, 1);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  @keyframes txSlideUp {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  /* Header: stack title row and action button */
  .tx-drawer-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 12px 16px;
  }

  .tx-drawer-header-left {
    gap: 0.75rem;
  }

  .tx-drawer-header-right {
    width: 100%;
  }

  .tx-drawer-header-right .tx-btn-outline {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* Close button: large enough to tap */
  .tx-close-btn {
    min-width: 44px;
    min-height: 44px;
  }

  /* Content padding reduced for small screens */
  .tx-drawer-content {
    padding: 1rem;
  }

  /* Title amount: slightly smaller */
  .tx-title-left h1 {
    font-size: 1.25rem;
  }

  /* Summary grid: single column (already handled at 768px in inline style,
     but we re-apply here for the 576px breakpoint to be explicit) */
  .tx-summary-grid {
    flex-direction: column !important;
    gap: 0 !important;
  }

  /* Events row: stack text + time on very small screens */
  .tx-event-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .tx-event-time {
    font-size: 0.75rem;
  }

  /* Blockchain hash: allow wrapping */
  .tx-hash-value {
    flex-wrap: wrap;
  }

  /* id-bar: ensure monospace input doesn't overflow */
  .tx-id-bar {
    overflow: hidden;
  }

  .tx-id-input {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Transactions.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;;6EAE6E;AAC7E;EACE,uDAAuD;EACvD;IACE,eAAe;EACjB;;EAEA,qDAAqD;EACrD;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,qEAAqE;EACrE;IACE,eAAe;EACjB;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,2BAA2B;EAC3B;IACE,SAAS;EACX;;EAEA,uDAAuD;EACvD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,mFAAmF;EACnF;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,QAAQ;IACR,gBAAgB;IAChB,mDAAmD;IACnD,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,yDAAyD;EACzD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,QAAQ;EACV;EACA,mBAAmB,cAAc;IAC/B,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,UAAU,CAAC;EACb,0CAA0C;EAC1C;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,UAAU;EACZ;;EAEA,4DAA4D;EAC5D;IACE,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;;EAEA,gCAAgC;;EAEhC,gDAAgD;EAChD;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA,2DAA2D;EAC3D;IACE,aAAa;EACf;;EAEA,4DAA4D;EAC5D;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,wCAAwC;EACxC;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA,uDAAuD;EACvD;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA,wCAAwC;EACxC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;EAChB;;EAEA,yBAAyB;EACzB;IACE,yCAAyC;IACzC,eAAe;IACf,wBAAwB;IACxB,eAAe;EACjB;;EAEA,0EAA0E;EAC1E;;IAEE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA,2CAA2C;;EAE3C,+EAA+E;EAC/E;IACE,iEAAiE;EACnE;;EAEA,iEAAiE;EACjE;IACE,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB,QAAQ,oCAAoC;IAClE,0BAA0B;IAC1B,YAAY;IACZ,4BAA4B;IAC5B,0CAA0C;IAC1C,yDAAyD;IACzD,gDAAgD;EAClD;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA,8CAA8C;EAC9C;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;EACpB;;EAEA;oEACkE;EAClE;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE,eAAe;EACjB;;EAEA,oDAAoD;EACpD;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/Transactions.jsx.\n * Loaded AFTER index.css (and after the page's own inline <style>) so\n * equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * Strategy:\n *   - Tablet (<=991px): toolbar wraps, status-tabs are compact.\n *   - Mobile (<=576px): full single-column layout, table → card view,\n *     detail drawer → bottom sheet, all touch targets >=44px.\n *\n * DO NOT EDIT src/index.css. All overrides live here.\n */\n\n/* ===========================================================================\n * TABLET (<=991px): compact toolbar & minor layout tweaks\n * ======================================================================== */\n@media (max-width: 991px) {\n  /* Allow toolbar to wrap so filter buttons don't clip */\n  .transactions-page .table-toolbar {\n    flex-wrap: wrap;\n  }\n\n  /* Search expands to fill available width on tablet */\n  .transactions-page .search-box {\n    max-width: 100%;\n    flex: 1 1 220px;\n  }\n\n  /* Status tabs: let the count drop below the label on small tablets */\n  .transactions-page .status-tab {\n    min-width: 80px;\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full single-column, app-like layout\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Page wrapper ---- */\n  .transactions-page {\n    gap: 16px;\n  }\n\n  /* ---- Page header: stack title + action button ---- */\n  .transactions-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 0;\n  }\n\n  .transactions-page .page-header h1 {\n    font-size: 22px;\n  }\n\n  .transactions-page .header-actions {\n    display: flex;\n  }\n\n  .transactions-page .header-actions .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ---- Status tabs: horizontal scroll so all fit without wrapping awkwardly ---- */\n  .transactions-page .status-tabs {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    gap: 8px;\n    padding: 0 0 4px;\n    /* hide scrollbar visually but keep it functional */\n    scrollbar-width: none;\n  }\n\n  .transactions-page .status-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .transactions-page .status-tab {\n    flex-shrink: 0;\n    min-width: 90px;\n    padding: 10px 12px;\n    min-height: 44px;\n  }\n\n  .transactions-page .status-tab .tab-count {\n    font-size: 16px;\n  }\n\n  /* ---- Toolbar: stack search above filter buttons ---- */\n  .transactions-page .table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .transactions-page .search-box {\n    max-width: 100%;\n    width: 100%;\n    flex: unset;\n  }\n\n  .transactions-page .search-box input {\n    width: 100%;\n    min-height: 44px;\n  }\n\n  .transactions-page .toolbar-actions {\n    display: inline-grid;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  .plan-choice-modal{max-width: 90%;\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    top: -30px;}\n  /* Toolbar buttons: minimum touch target */\n  .transactions-page .btn-toolbar,\n  .transactions-page .btn-clear-filters {\n    min-height: 44px;\n    padding: 10px 12px;\n    flex-shrink: 0;\n    width:100%;\n  }\n\n  /* Dropdown menus: full-width on mobile so they don't clip */\n  .transactions-page .dropdown-menu {\n    left: 0;\n    right: auto;\n    min-width: 200px;\n    max-height: 60vh;\n    overflow-y: unset;\n    width: 100%;\n    z-index: 9999;\n  }\n\n  /* ---- Table → card view ---- */\n\n  /* Remove horizontal scroll from the container */\n  .transactions-page .transactions-table-container {\n    overflow: visible;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n  }\n\n  /* Hide the actual <table> – we use the card list instead */\n  .transactions-page .transactions-table {\n    display: none;\n  }\n\n  /* The card list is shown only on mobile via .tx-card-list */\n  .transactions-page .tx-card-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  /* Each transaction row becomes a card */\n  .transactions-page .tx-row-card {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    padding: 14px 16px;\n    cursor: pointer;\n    transition: background 0.15s;\n  }\n\n  .transactions-page .tx-row-card:active {\n    background: var(--bg-secondary);\n  }\n\n  /* Card top row: amount (left) + status badge (right) */\n  .transactions-page .tx-row-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n\n  .transactions-page .tx-row-card-amount {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n  }\n\n  /* Card bottom row: type·method + date */\n  .transactions-page .tx-row-card-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .transactions-page .tx-row-card-meta {\n    font-size: 12px;\n    color: var(--text-secondary);\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    align-items: center;\n    min-width: 0;\n  }\n\n  .transactions-page .tx-row-card-meta .tx-row-card-type {\n    color: var(--text-muted);\n  }\n\n  .transactions-page .tx-row-card-date {\n    font-size: 12px;\n    color: var(--text-muted);\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  /* tx-hash chip on card */\n  .transactions-page .tx-row-card-hash {\n    font-family: 'Monaco', 'Menlo', monospace;\n    font-size: 11px;\n    color: var(--text-muted);\n    margin-top: 6px;\n  }\n\n  /* empty/loading states still look good inside the transparent container */\n  .transactions-page .transactions-table-container .empty-state,\n  .transactions-page .transactions-table-container .loading-container {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n  }\n\n  /* ---- Pagination ---- */\n  .transactions-page .pagination-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .transactions-page .pagination-info {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 8px;\n    font-size: 13px;\n  }\n\n  .transactions-page .page-size-select {\n    min-height: 44px;\n  }\n\n  .transactions-page .pagination-controls {\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .transactions-page .pagination-btn,\n  .transactions-page .page-number {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* ---- Detail drawer → bottom sheet ---- */\n\n  /* Full-viewport overlay (already exists in inline style; this reinforces it) */\n  .tx-drawer-overlay {\n    /* already position: fixed with z-index: 999 — no change needed */\n  }\n\n  /* Bottom sheet: slides up from bottom, full-width, rounded top */\n  .tx-detail-drawer {\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100% !important;       /* override the inline width:600px */\n    max-width: 100% !important;\n    height: 92vh;\n    border-radius: 16px 16px 0 0;\n    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);\n    animation: txSlideUp 0.28s cubic-bezier(0.32, 0.72, 0, 1);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n\n  @keyframes txSlideUp {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  /* Header: stack title row and action button */\n  .tx-drawer-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    padding: 12px 16px;\n  }\n\n  .tx-drawer-header-left {\n    gap: 0.75rem;\n  }\n\n  .tx-drawer-header-right {\n    width: 100%;\n  }\n\n  .tx-drawer-header-right .tx-btn-outline {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* Close button: large enough to tap */\n  .tx-close-btn {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* Content padding reduced for small screens */\n  .tx-drawer-content {\n    padding: 1rem;\n  }\n\n  /* Title amount: slightly smaller */\n  .tx-title-left h1 {\n    font-size: 1.25rem;\n  }\n\n  /* Summary grid: single column (already handled at 768px in inline style,\n     but we re-apply here for the 576px breakpoint to be explicit) */\n  .tx-summary-grid {\n    flex-direction: column !important;\n    gap: 0 !important;\n  }\n\n  /* Events row: stack text + time on very small screens */\n  .tx-event-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .tx-event-time {\n    font-size: 0.75rem;\n  }\n\n  /* Blockchain hash: allow wrapping */\n  .tx-hash-value {\n    flex-wrap: wrap;\n  }\n\n  /* id-bar: ensure monospace input doesn't overflow */\n  .tx-id-bar {\n    overflow: hidden;\n  }\n\n  .tx-id-input {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
